angular.module('shared').factory('PeriodicalUnits', function() {
  return {
    days: 'daily',
    weeks: 'weekly',
    months: 'monthly',
    years: 'yearly'
  };
});
